import React, { useRef } from "react"
import UploadIcon from "images/inline/ugc-video/upload.svg"
const UploadButton = ({ onFileSelection = function () {}, label = "Upload File" }) => {
  const handleFileUpload = event => {
    onFileSelection(event.target.files)
  }
  const inputElement = useRef()
  return (
    <div className={`receipt-upload-button`}>
      <React.Fragment>
        <input ref={inputElement} onChange={handleFileUpload} type="file" style={{ display: "none" }} multiple={false} accept="image/*, video/*" />
        <button className={"btn upload-button"} onClick={() => inputElement.current.click()}>
          <UploadIcon />
          {label}
        </button>
      </React.Fragment>
    </div>
  )
}

export default UploadButton
